import store from 'gkCon/store'

let speakerConfig = {
  '1': { id: 1, name: '联席主席' },
  '2': { id: 2, name: '主题演讲嘉宾' },
  '3': { id: 3, name: '专题出品人' },
  '4': { id: 4, name: '专题演讲嘉宾' },
  '5': { id: 5, name: '智囊团' },
  '6': { id: 6, name: '培训讲师' }
}

store.commit('SET_SPEAKERS_MAP', speakerConfig)

export default store
